module.exports = __webpack_public_path__ + "static_pest_wiki_details/img/flea_type01.212a8e1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/product_info/flea_type01.png
// module id = RcrS
// module chunks = 0